import { Component, Input } from "@angular/core";
import { IUserTile } from "../user.functions";

export enum EUserTileSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
}

@Component({
  standalone: false,
  selector: 'app-management-user-tile',
  styleUrl: './user-tile.component.scss',
  templateUrl: './user-tile.component.html',
})
export class UserTileComponent {
  @Input()
  tile: IUserTile;

  @Input()
  tileSize: EUserTileSize = EUserTileSize.Medium;
}
